// nativePush.js(프로토타입 패치, React 트리 밖)가 폰 푸시를 받으면 window에 커스텀 이벤트를
// 쏜다. 이 컴포넌트가 그걸 받아 ① 포그라운드 수신 시 notistack 스낵바("열기" 액션) + 벨 목록
// 새로고침, ② 탭(백그라운드/종료 상태 포함) 시 React Router navigate를 담당한다.
// 웹에서는 nativePush.js가 이벤트를 쏘지 않으므로(네이티브 전용) 이 컴포넌트도 사실상 아무 일도
// 하지 않는다 - App.js 최상단에 NativeDownloadToastBridge와 나란히 한 번만 마운트해 두면 된다.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { getNoties } from '../../modules/auth';
import { consumePendingPushLink } from '../../lib/nativePush';
import { safeInternalLink } from '../../utils/pushLink';

const NativePushBridge = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const user = useSelector(({ auth }) => auth.user);

  // 푸시를 탭했을 때 로그인 전이었다면(nativePush.js가 sessionStorage에 잠시 보관) 로그인이
  // 끝나는 순간(user가 채워지는 순간) 그 화면으로 이어서 이동한다.
  useEffect(() => {
    if (!user) return;
    const pendingLink = consumePendingPushLink();
    if (pendingLink) {
      navigate(pendingLink);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    const onReceived = (event) => {
      const notification = event.detail || {};
      const title = notification.title || 'KMES';
      const body = notification.body || '';
      const link = safeInternalLink(notification.data?.link);

      enqueueSnackbar(body ? `${title}: ${body}` : title, {
        variant: 'info',
        autoHideDuration: 6000,
        action: (snackbarKey) => (
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              if (link) navigate(link);
            }}
          >
            열기
          </Button>
        ),
      });

      // 포그라운드에서 받은 푸시는 보통 방금 생긴 벨 알림과 짝이다 - 목록을 바로 갱신해 둔다.
      dispatch(getNoties());
    };

    const onTapped = (event) => {
      const { link } = event.detail || {};
      if (link) navigate(link);
    };

    window.addEventListener('kmes:push-received', onReceived);
    window.addEventListener('kmes:push-tapped', onTapped);
    return () => {
      window.removeEventListener('kmes:push-received', onReceived);
      window.removeEventListener('kmes:push-tapped', onTapped);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, dispatch, enqueueSnackbar]);

  return null;
};

export default NativePushBridge;
